import dayjs from 'dayjs';
import { WorkTimeType } from 'shared/types';

import getNearestPreOrderWorkTime from './getNearestPreOrderWorkTime';

type Props = {
	schedule: WorkTimeType[];
	delay?: number;
	minPreOrdersDayCount?: number;
};

/**
 * Find if given schedule is available at the moment.
 * */
const isScheduleNowAvailable = ({ schedule, delay, minPreOrdersDayCount }: Props): boolean => {
	const now = dayjs();
	const { fromDelayed, tillDelayed } = getNearestPreOrderWorkTime({
		workTimeAll: schedule,
		delay,
		minPreOrdersDayCount,
	});

	return !(now.isBefore(fromDelayed) || now.isAfter(tillDelayed));
};

export default isScheduleNowAvailable;
